module.exports = __webpack_public_path__ + "static/media/10tips-job-interview.c04b4052.mp4";